/* @sravni/react-header version 0.2.43 */
import { __rest, __read, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { TextInput } from '@sravni/react-design-system/lib/TextInput';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Cross, Search as Search$1, ArrowRight } from '@sravni/react-icons';
import '../../Navigation/index.js';
import modules_68267011 from '../styles/Search.module.less.js';
import Navigation from '../../Navigation/src/Navigation.js';
import NavigationItem from '../../Navigation/src/NavigationItem.js';

/**
 * @description Desktop search component.
 *
 * @component
 * @example
 * ```jsx
 * <DesktopSearch />
 * ```
 */
var Search = React.forwardRef(function (props, ref) {
    var visible = props.visible, url = props.url, isMobileHeader = props.isMobileHeader, className = props.className, onOpen = props.onOpen, onClose = props.onClose, restProps = __rest(props, ["visible", "url", "isMobileHeader", "className", "onOpen", "onClose"]);
    var cx = useStyles(modules_68267011);
    var _a = __read(React.useState(''), 2), value = _a[0], setValue = _a[1];
    var handleChangeInput = React.useCallback(function (e) {
        // @ts-ignore
        setValue(e.target.value);
    }, []);
    var handleClickButton = React.useCallback(function () {
        redirect(value);
    }, [value]);
    var redirect = function (term) {
        if (!term)
            return;
        location.href = new URL("?q=" + encodeURIComponent(term), url).toString();
    };
    React.useEffect(function () {
        function onKeyDown(e) {
            if (e.key === 'Enter') {
                redirect(value);
            }
        }
        document.addEventListener('keydown', onKeyDown);
        return function () {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [value]);
    var searchButton = React.useMemo(function () {
        if (visible) {
            return (React.createElement(Button, { className: cx('customButton'), size: 36, variant: "primary", color: "gray", onClick: onClose },
                React.createElement(Icon, { icon: React.createElement(Cross, null) })));
        }
        return (React.createElement(Button, { className: cx('customButton'), size: 36, variant: "text", onClick: onOpen },
            React.createElement(Icon, { icon: React.createElement(Search$1, null) })));
    }, [visible]);
    var submitButton = React.useMemo(function () {
        return isMobileHeader ? React.createElement(Icon, { icon: React.createElement(ArrowRight, null) }) : 'Найти';
    }, [isMobileHeader]);
    return isMobileHeader ? (React.createElement(Space, { size: 16, className: cx('mobileSearchMenu') },
        React.createElement(TextInput, { placeholder: "\u0427\u0442\u043E \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043D\u0430\u0439\u0442\u0438?", value: value, onChange: handleChangeInput }),
        React.createElement(Button, { size: 60, variant: "primary", className: cx('button'), onClick: handleClickButton }, submitButton))) : (React.createElement(Navigation, __assign({ ref: ref, className: cx(className) }, restProps),
        React.createElement(NavigationItem, { clean: true, wide: true, visible: visible, control: searchButton },
            React.createElement(Space, { size: 16 },
                React.createElement(TextInput, { placeholder: "\u0427\u0442\u043E \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043D\u0430\u0439\u0442\u0438?", value: value, onChange: handleChangeInput }),
                React.createElement(Button, { size: 60, variant: "primary", className: cx('button'), onClick: handleClickButton }, submitButton)))));
});
Search.defaultProps = {
    isMobileHeader: false
};

export { Search as default };
//# sourceMappingURL=Search.js.map
